import { useTranslation } from 'react-i18next';
export function useLogiReportsTranslation() {
    return useTranslation('logi-reports');
}
